module.exports = __webpack_public_path__ + "static/media/ic_html.2ad6e724.svg";